module.exports = __webpack_public_path__ + "static/media/36.8c3dbffe.jpg";